export default __webpack_public_path__ + "static/media/problemsolving.2e3a2604.png";